
export const getMenuScheme = function () {
  return [
    {
      name: 'MyAccount',
      templateName: 'Start',
      isVisible: true,
      isOnMobileVisible: true,
      isVisibleOnBottom: true,
      icon: require('@/assets/start.svg'),
      iconActive: require('@/assets/start_black.svg'),
      availableForAccountsType: ['prepaid', 'postpaid'],
      isDependentOnAcl: false,
      aclPrivilege: null,
    },
    {
      name: 'Recharges',
      templateName: 'Doładowania',
      isVisible: true,
      isOnMobileVisible: true,
      isVisibleOnBottom: true,
      icon: require('@/assets/payments.svg'),
      iconActive: require('@/assets/payments_black.svg'),
      availableForAccountsType: ['prepaid'],
      isDependentOnAcl: false,
      aclPrivilege: null,
    },
    {
      name: 'PaymentsAndInvoices',
      templateName: 'Płatności',
      isVisible: true,
      isOnMobileVisible: true,
      isVisibleOnBottom: true,
      icon: require('@/assets/payments.svg'),
      iconActive: require('@/assets/payments_black.svg'),
      availableForAccountsType: ['postpaid'],
      isDependentOnAcl: true,
      aclPrivilege: 'can_see_payments',
    },
    {
      name: 'Services',
      templateName: 'Usługi',
      isVisible: true,
      isOnMobileVisible: true,
      isVisibleOnBottom: true,
      icon: require('@/assets/services.svg'),
      iconActive: require('@/assets/services_black.svg'),
      availableForAccountsType: ['prepaid', 'postpaid'],
      isDependentOnAcl: true,
      aclPrivilege: 'can_see_services',
    },
    {
      name: 'Billing',
      templateName: 'Billing',
      isVisible: true,
      isOnMobileVisible: true,
      isVisibleOnBottom: true,
      icon: require('@/assets/billing.svg'),
      iconActive: require('@/assets/billing_black.svg'),
      availableForAccountsType: ['prepaid', 'postpaid'],
      isDependentOnAcl: false,
      aclPrivilege: null,
    },
    {
      name: 'Complains',
      templateName: 'Kontakt',
      isVisible: true,
      isOnMobileVisible: true,
      isVisibleOnBottom: true,
      icon: require('@/assets/contact.svg'),
      iconActive: require('@/assets/contact_black.svg'),
      availableForAccountsType: ['prepaid', 'postpaid'],
      isDependentOnAcl: true,
      aclPrivilege: 'can_see_complains',
    },
    {
      name: 'Logout',
      templateName: 'Wyloguj się',
      isVisible: true,
      isOnMobileVisible: true,
      isVisibleOnBottom: false,
      icon: null,
      iconActive: null,
      availableForAccountsType: ['prepaid', 'postpaid'],
      isDependentOnAcl: false,
      aclPrivilege: null,
    },
  ];
};

export const visibilityDependOnAcl = function (_this, menu) {
  try {
    return menu.isDependentOnAcl && menu.aclPrivilege in _this.acl.privileges ? _this.acl.privileges[menu.aclPrivilege] : true;
  } catch (error) {
    if (error instanceof TypeError) {
      return true;
    }
    throw error;
  }
};

export const visibilityDependOnAccountTypes = function (_this, menu) {
  return menu.availableForAccountsType.includes(_this.subscriber.type);
};

export const visibilityJustOnMobile = function (_this, menu) {
  if (_this.mobileMenuIsVisible) {
    return !!menu.isOnMobileVisible;
  }
  return !!menu.isVisible;
};



// WEBPACK FOOTER //
// ./src/components/Panel/MenuCommon.js